import { Route } from 'react-router-dom'
import { useSelector } from 'react-redux'

import BudgetReverse from './BudgetReverse'
import BudgetQuestion from './BudgetQuestion'
import BudgetSummaryScreen from './BudgetSummaryScreen'

import BudgetPanel from '../assessment/BudgetPanel'
import ProtectUnauthenticatedChildren from '../ProtectUnauthenticatedChildren'

const BudgetRoutes = props => {
  const hasFileAccess = useSelector(
    state => state.authenticationState?.userProfile?.hasFileAccess
  )

  return (
    <>
      <Route path="/budget/old/reverse" component={BudgetReverse} />
      <Route path="/budget/old/round/:roundId?" component={BudgetQuestion} />
      <Route
        path="/budget/old/summary"
        render={() => (
          <BudgetSummaryScreen
            showSave={
              dynamicValues.userProfile?.isRoot ||
              hasFileAccess ||
              dynamicValues.isSubscriber
            }
          />
        )}
      />
    </>
  )
}

export default BudgetRoutes
